import React from "react";
import ComicBase from "../ComicBase";

export default function ComicNaruto() {
  return (
    <ComicBase
      titulo="TOUCHUUKASOU parte 5"
      portada="https://fullcomics18.org/img7/touchuukasou5-1.jpg"
    paginas={[
  "https://fullcomics18.org/img7/touchuukasou5-1.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-2.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-3.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-4.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-5.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-6.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-7.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-8.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-9.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-10.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-11.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-12.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-13.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-14.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-15.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-16.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-17.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-18.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-19.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-20.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-21.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-22.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-23.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-24.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-25.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-26.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-27.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-28.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-29.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-30.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-31.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-32.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-33.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-34.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-35.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-36.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-37.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-38.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-39.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-40.jpg",
  "https://fullcomics18.org/img7/touchuukasou5-41.jpg"
]}
      sugeridos={[]}


      info={{
        grupo: "shoot the moon",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "Original",
    personajes: [" "],
etiquetas: ["Beauty Mark", "Big Ass", "Big Breasts", "Closed Eyes", "Cunnilingus", "Digital Fingering", "Freckles", "Hidden Sex", "Multi-work Series", "Nakadashi", "Netorare", "Ponytail", "Shaved Head", "Sole Female", "Sole Male", "Sweating"],
    artistas: "Fuetakishi",
      }}
    />
  );
}

export const infoManga = {
  titulo: "TOUCHUUKASOU parte 5",
  portada: "https://fullcomics18.org/img7/touchuukasou5-1.jpg",
  reverso: "https://fullcomics18.org/img7/touchuukasou5-3.jpg",
   fecha:"2026-05-16",


  info: {
    grupo: "shoot the moon",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "Original",
    personajes: [" "],
etiquetas: ["Beauty Mark", "Big Ass", "Big Breasts", "Closed Eyes", "Cunnilingus", "Digital Fingering", "Freckles", "Hidden Sex", "Multi-work Series", "Nakadashi", "Netorare", "Ponytail", "Shaved Head", "Sole Female", "Sole Male", "Sweating"],
    artistas: "Fuetakishi",
  },
};
